<div class="floating_btn z-40">
  <a target="_blank" [href]="whatsappLink" aria-label="Contact us on WhatsApp">
    <div class="contact_icon">
      <fa-icon [icon]="faWhatsapp" class="my-float"></fa-icon>
    </div>
  </a>
  <p class="text_icon">Talk to us?</p>
</div>
